import StudentPosterProduct from './components/StudentPosterProduct'
import StudentPosterLoader from './components/StudentPosterLoader'
import StudentPosterBorder from './components/StudentPosterBorder'

export default {
    install(Vue, option) {
        Vue.component('StudentPosterProduct', StudentPosterProduct);
        Vue.component('StudentPosterLoader', StudentPosterLoader);
        Vue.component('StudentPosterBorder', StudentPosterBorder);
    }
};
